import React from 'react';
import {
    CheckIcon,
    PrimaryDescription,
    Title,
    Wrapper,
    AccountHelperContainer,
    LinkButton,
} from 'src/domains/players/webview/components/Account/forgotPasswordTab/resetPasswordSent/ResetPasswordSent.style';
import { AccountHelperInfo } from 'src/domains/players/webview/components/Account/component/accountHelperInfo/AccountHelperInfo';
import { AlignBottomWrapper } from 'src/domains/players/webview/components/Account/forgotPasswordTab/ForgotPasswordTab.style';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

interface ResetPasswordSentPropsType {
    goBackToForgotPassword: () => void;
}

export const ResetPasswordSent = observer(
    'ResetPasswordSent',
    ({ goBackToForgotPassword }: ResetPasswordSentPropsType) => {
        const common = useCommon();
        const starRouter = StarRouter.get(common);

        return (
            <AccountHelperContainer>
                <Wrapper>
                    <CheckIcon />
                    <Title data-test='password-recovery-link-sent-title'>
                        <I18n
                            langKey='account.reset-password-sent.title'
                            defaultText='Password recovery link Sent'
                        />
                    </Title>
                    <PrimaryDescription data-test='password-recovery-primary-description'>
                        <I18n
                            langKey='account.reset-password-sent.primary-desc'
                            defaultText='We have sent you an email with instructions and a link on how to reset your password'
                        />
                    </PrimaryDescription>
                    <LinkButton
                        dataTest='back-to-login-button'
                        onClick={starRouter.redirectToLogin}
                        size='large'
                    >
                        <I18n
                            langKey='account.reset-password-sent.login-link'
                            defaultText='Back to Login'
                        />
                    </LinkButton>
                    <LinkButton
                        dataTest='resend-email-button'
                        onClick={goBackToForgotPassword}
                        size='large'
                        version='secondary-light'
                    >
                        <I18n
                            langKey='account.reset-password-sent.resend-link'
                            defaultText='Resend Email'
                        />
                    </LinkButton>
                </Wrapper>
                <AlignBottomWrapper>
                    <AccountHelperInfo />
                </AlignBottomWrapper>
            </AccountHelperContainer>
        );
    }
);
